import StripChat from "./StripChat";
import { Fragment } from "react";

interface IProps {
  position: number;
}

const AD_POSITION_FACTOR = 5;

export const StripChatAdDispatcher = (props: IProps) => {
  const { position } = props;

  const canShow = position === 2 || (position - 2) % AD_POSITION_FACTOR === 0;
  const index = (position - 2) % AD_POSITION_FACTOR === 0 ? (position - 2) / AD_POSITION_FACTOR : 0;

  return (
    <Fragment>
      {
        canShow && <StripChat key="StripChat" index={index}/>
      }
    </Fragment>
  );
};
